import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/Rockstar/ProductShowcase";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet";

const Rockstar = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
       <Helmet>
        <title>Rockstar Strain - Potent & Relaxing | BeyondBloom™</title>
        <meta
          name="description"
          content="Rockstar is a potent and relaxing strain with an earthy, spicy profile, perfect for unwinding after a long day."
        />
        <meta
          name="keywords"
          content="Rockstar strain, relaxing cannabis, earthy cannabis, potent marijuana, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Rockstar Strain - Potent & Relaxing | BeyondBloom™" />
        <meta
          property="og:description"
          content="Rockstar is a potent and relaxing strain with an earthy, spicy profile, perfect for unwinding after a long day."
        />
        <meta property="og:image" content="/images/rockstar.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/rockstar" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Rockstar Strain - Potent & Relaxing | BeyondBloom™" />
        <meta
          name="twitter:description"
          content="Rockstar is a potent and relaxing strain with an earthy, spicy profile, perfect for unwinding after a long day."
        />
        <meta name="twitter:image" content="/images/rockstar.png" />
      </Helmet>

      {" "}
      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Rockstar;
